module.exports = __webpack_public_path__ + "media/recipes/71-df002e55.png";